import PropertiesReportRow from 'app/shared/model/PropertiesReportRow';
import Listing from 'app/shared/model/Listing';

const PropertiesReport = ({
    clickCount = 0,
    leadCount = 0,
    viewCount = 0,
    daysOnMarketCount = 0,
    analytics = [],
    propertyDetails = {},
} = {}) => ({
    clickCount: Number(clickCount),
    leadCount: Number(leadCount),
    viewCount: Number(viewCount),
    daysOnMarketCount: Number(daysOnMarketCount),
    rows: analytics.map(item => PropertiesReportRow(item)),
    propertyDetails: Object.keys(propertyDetails).reduce((acc, key) => {
        acc[key] = Listing(propertyDetails[key]);
        return acc;
    }, {}),
});

export default PropertiesReport;
